// extracted by mini-css-extract-plugin
export default {"socialResponsibilitySection":"SocialResponsibilitySection_socialResponsibilitySection__4d0wS"};